module.exports = __webpack_public_path__ + "img/ss-o-3.303ab45e.png";